module.exports = __webpack_public_path__ + "c5885de071248a825f528d793865171c.png";